<template>
<div class="vliveContent">
    <div class="content-box">
        <el-tabs v-model="activeNameTab" addable @edit="handleTabsEdit">
            <el-tab-pane :key="index" v-for="(item, index) in list" :name="item.columntype+''+index">
                <span slot="label">
                    <el-dropdown>
                        <span class="el-dropdown-link">
                            {{item.columnname}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  @click.native="handleVliveContentEdit(item)">重命名</el-dropdown-item>
                            <el-dropdown-item  @click.native="handleVliveContentDel(item)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </el-tab-pane>
        </el-tabs>
    </div>
    <vliveContentEdit ref="vliveContentEdit" @getVliveContentList="findCwLivetvcolumninfo"></vliveContentEdit>
</div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor'
import {mapGetters, mapActions} from 'vuex'
import VliveContentEdit from 'views/cms/vlive/components/vliveContentComponents/vliveContentEdit2'
import {delVliveContent, getCwLivetvcolumninfo, deleteCwLivetvcolumninfoById} from 'api/api'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveContent',
    data() {
        return {
            activeNameTab: '',
            contentthemecolor: '',
            columntype: [], // 已添加的内容类型
            list: []
        }
    },
    mounted() {
        this.findCwLivetvcolumninfo()
    },
    methods: {
        // 查询直播栏目列表
        findCwLivetvcolumninfo() {
            this.setLoading(true)
            var params = {
                liveinnerid: this.$route.query.id
            }
            getCwLivetvcolumninfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.list = data.data.content
                    this.activeNameTab = this.list[0].columntype+''+0
                    // this.setVliveModelContentList(this.list)
                    this.$emit('setNavData', this.list)
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 重命名直播栏目弹窗
        handleVliveContentEdit(obj) {
            this.$refs.vliveContentEdit.openDialog('edit', obj)
        },
        // 删除直播栏目弹窗
        handleVliveContentDel(row) {
            this.$confirm(vliveMsg.delVliveContent.msg, vliveMsg.delVliveContent.title, {
                confirmButtonText: vliveMsg.delVliveContent.confirmText,
                cancelButtonText: vliveMsg.delVliveContent.cancelText
            }).then(() => {
                this._delVliveContent(row)
            })
        },
        handleTabsEdit(targetName, action) {
            if (action === 'add') {
                if (this.list.length < 5) {
                    // this.$refs.vliveContentEdit.openDialog('add', '', this.list.length + 1)
                    this.$refs.vliveContentEdit.openDialog('add', '', this.list[this.list.length - 1].showorder + 1)
                } else {
                    this.$alert('最多添加5个分类！', '提示', {
                        dangerouslyUseHTMLString: true
                    })
                }
            }
            if (action === 'remove') {
                let tabs = this.list
                let activeName = this.activeNameTab
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1]
                            if (nextTab) {
                                activeName = nextTab.name
                            }
                        }
                    })
                }

                this.activeNameTab = activeName
                this.list = tabs.filter(tab => tab.name !== targetName)
            }
        },
        // 删除直播栏目
        _delVliveContent(row) {
            this.setLoading(true)
            deleteCwLivetvcolumninfoById({
                data: {
                    innerid: row.innerid
                },
                success: data => {
                    this.setLoading(false)
                    this.findCwLivetvcolumninfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelContentList',
            'setVliveModelThemeColor',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.contentthemecolor = this.vliveModel.contentthemecolor
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {
        VliveContentEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContent {
    width: 800px;
    .flex{
        width: 800px;
        @include flexBox(space-between);
        .theme-color{
            @include flexBox(flex-start);
            .title{
                margin-right: 10px;
            }
        }
    }
    .content-box{
        margin-top: 20px;
    }
    .el-tabs__header{
        border: 1px solid $line;
        border-bottom-width: 0;
        height: 40px;
        .el-tabs__new-tab{
            box-sizing: border-box;
            width: 100px;
            height: 40px;
            line-height: 40px;
            margin: 0;
            border-width: 0;
            border-left: 1px solid $line;
            border-bottom: 1px solid $line;
        }
    }
    .el-tabs__header::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #E4E7ED;
        z-index: 1;
    }
}
</style>
